/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_Unknown_CodeInputs */

const en_friends_unknown_code = /** @type {(inputs: Friends_Unknown_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This code doesn’t exist.`)
};

const de_friends_unknown_code = /** @type {(inputs: Friends_Unknown_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Code gibt es nicht.`)
};

/**
* | output |
* | --- |
* | "This code doesn’t exist." |
*
* @param {Friends_Unknown_CodeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_unknown_code = /** @type {((inputs?: Friends_Unknown_CodeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_Unknown_CodeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_unknown_code(inputs)
	return en_friends_unknown_code(inputs)
});